if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.viewer.addEventListener("click", this._onClickFunc.bind(this));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }
   _onClickFunc(event) {
  if (!this.elements.thumbnails || !this.mql.matches) {
    return;
  }

  /*
   * Keep magnifier, videos and other controls working.
   */
  if (
    event.target.closest(
      [
        '.product__media-toggle',
        '.product__media-icon',
        'button',
        'a',
        'video',
        'model-viewer',
        'deferred-media',
        '.deferred-media__poster'
      ].join(',')
    )
  ) {
    return;
  }

  /*
   * Important:
   * Only include thumbnails that are actually visible.
   * Hidden variant thumbnails must not be treated as
   * another next slide.
   */
  const thumbnailItems = Array.from(
    this.elements.thumbnails.querySelectorAll('[data-target]')
  ).filter((item) => {
    const style = window.getComputedStyle(item);

    return (
      !item.hidden &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      item.getClientRects().length > 0
    );
  });

  if (thumbnailItems.length <= 1) return;

  let currentIndex = thumbnailItems.findIndex((item) => {
    const button = item.querySelector('button');

    return (
      button &&
      button.getAttribute('aria-current') === 'true'
    );
  });

  /*
   * Fallback using the currently active large image.
   */
  if (currentIndex < 0) {
    const activeMedia = this.elements.viewer.querySelector(
      '[data-media-id].is-active'
    );

    if (activeMedia) {
      currentIndex = thumbnailItems.findIndex((item) => {
        return (
          item.dataset.target ===
          activeMedia.dataset.mediaId
        );
      });
    }
  }

  if (currentIndex < 0) return;

  const viewerRect =
    this.elements.viewer.getBoundingClientRect();

  const clickedNext =
    event.clientX >
    viewerRect.left + viewerRect.width / 2;

  /*
   * Stop completely when clicking next on the final
   * visible thumbnail.
   */
  if (
    clickedNext &&
    currentIndex === thumbnailItems.length - 1
  ) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return;
  }

  /*
   * Stop completely when clicking previous on the first
   * visible thumbnail.
   */
  if (!clickedNext && currentIndex === 0) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return;
  }

  const targetIndex = clickedNext
    ? currentIndex + 1
    : currentIndex - 1;

  const targetItem = thumbnailItems[targetIndex];

  if (!targetItem) return;

  const targetMediaId = targetItem.dataset.target;

  if (!targetMediaId) return;

  /*
   * Verify the corresponding large media exists before
   * changing the active image.
   */
  const targetMedia = this.elements.viewer.querySelector(
    `[data-media-id="${CSS.escape(targetMediaId)}"]`
  );

  if (!targetMedia) return;

  event.preventDefault();
  event.stopPropagation();

  this.setActiveMedia(targetMediaId, false);
}
    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }
    
    setActiveMedia(mediaId, prepend) {      
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
